@if (dataContext && form) {
  <section class="brf-transfer">
    <form class="brf-transfer__form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
      <div class="header brf-transfer__header">
        <h1>{{ 'COOPERATIVE_HOUSING.TRANSFER' | translate }}</h1>
      </div>

      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <p class="brf-transfer__meta">
            <strong>{{ 'LEASE_AGREEMENT.LEASE_AGREEMENT_NUMBER' | translate }}:</strong>
            {{ dataContext.leaseAgreementNumber }}
          </p>
          <p class="brf-transfer__meta">
            <strong>{{ 'RENTAL_OBJECT_FORM.RENTAL_OBJECT_NUMBER_LABEL' | translate }}:</strong>
            {{ dataContext.rentalId }}
          </p>
        </astral-layout-group>
      </section>

      <section class="astral-section-surface astral-stack-m">
        <h4>{{ 'COOPERATIVE_HOUSING.TRANSFER_INFORMATION' | translate }}</h4>

        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-select [control]="form.controls['transferType']" [itemsSource]="transferTypes"></astral-select>
          <astral-date-picker
            [control]="form.controls['agreementDate']"
            [helpText]="'COOPERATIVE_HOUSING.HELP_TEXT.AGREEMENT_DATE'"
          ></astral-date-picker>
          <astral-date-picker
            [control]="form.controls['fromDate']"
            [helpText]="'COOPERATIVE_HOUSING.HELP_TEXT.ACCESS_DATE'"
          ></astral-date-picker>
          @if (showSellAmount) {
            <app-money-box [control]="form.controls['purchaseAmount']" [round]="true"></app-money-box>
            <app-money-box [control]="form.controls['additionalPayment_639']" [round]="true"></app-money-box>
          }
        </astral-layout-group>
      </section>

      <section class="astral-section-surface astral-stack-m">
        <h4>{{ 'COOPERATIVE_HOUSING.TRANSFER_BUYERS' | translate }}</h4>

        <div class="astral-stack-m">
          @for (buyerForm of $any(buyers.controls); track buyerForm; let i = $index) {
            <section class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle">
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                <div class="astral-grid-span-2">
                  <app-autocomplete-remote
                    [control]="buyerForm.controls['contactId']"
                    [service]="tenantService"
                    (itemSelected)="buyerSelected($event, i)"
                  ></app-autocomplete-remote>
                </div>
                <astral-input [control]="buyerForm.controls['acquiredShare']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
                <astral-date-picker [control]="buyerForm.controls['memberFrom']"></astral-date-picker>
                <astral-date-picker [control]="buyerForm.controls['approvalDate']"></astral-date-picker>
                @if (isDwelling) {
                  <astral-toggle [control]="buyerForm.controls['changeAddress']"></astral-toggle>
                }
                @if (buyers.length > 1) {
                  <div class="astral-delete-action astral-form-adjacent-action">
                    <astral-button
                      variant="secondary"
                      size="small"
                      type="button"
                      icon="trash"
                      labelKey="DELETE_BTN"
                      (click)="removeBuyer(i)"
                    ></astral-button>
                  </div>
                }
              </astral-layout-group>
            </section>
          }
        </div>

        <div>
          <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_BTN" (click)="addBuyer()"></astral-button>
        </div>
      </section>

      <section class="astral-section-surface astral-stack-m">
        <h4>{{ 'COOPERATIVE_HOUSING.TRANSFER_SELLERS' | translate }}</h4>

        @if (showTabbedButtons) {
          <app-tab-group [options]="modeSelection" [control]="form.controls['mode']">
            @for (item of modeSelection; track item) {
              <app-tab [value]="item.value" label="{{ item.label | translate }}" [template]="item.template"></app-tab>
            }
          </app-tab-group>
        }

        <div class="astral-stack-m">
          @for (sellerForm of $any(sellers.controls); track sellerForm; let i = $index) {
            <section class="astral-section-surface astral-section-surface--compact astral-section-surface--subtle astral-stack-m">
              @if (!isDivisionOfProperty || !sellerForm.controls['isBuyer'].value) {
                <h5>{{ sellerForm.controls['name'].value }}</h5>
              }

              @if (!sellerForm.controls['isBuyer'].value) {
                <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                  <astral-input [control]="sellerForm.controls['ownedShare']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
                  <astral-input [control]="sellerForm.controls['soldShare']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
                  <astral-toggle [control]="sellerForm.controls['endMembership']"></astral-toggle>
                  @if (sellerForm.controls['endMembership'].value) {
                    <astral-date-picker [control]="sellerForm.controls['memberTo']"></astral-date-picker>
                  }
                </astral-layout-group>

                <div class="astral-stack-s">
                  <h6>{{ 'COOPERATIVE_HOUSING.TRANSFER_BUY_INFORMATION' | translate }}</h6>
                  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                    <astral-date-picker [control]="sellerForm.controls['buyDate_640']"></astral-date-picker>
                    <app-money-box [round]="true" [control]="sellerForm.controls['buyAmount_643']"></app-money-box>
                  </astral-layout-group>
                </div>

                <div class="astral-stack-s">
                  <h6>{{ 'COOPERATIVE_HOUSING.TRANSFER_ADDRESS_AFTER_SELL' | translate }}</h6>
                  <app-postal-address [group]="sellerForm.controls['postalAddress']" [model]="sellerAddresses[i]" [title]="''"></app-postal-address>
                </div>
              }

              @if (sellerForm.controls['isBuyer'].value && !isDivisionOfProperty) {
                <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                  <astral-input [control]="sellerForm.controls['ownedShare']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
                </astral-layout-group>
              }
            </section>
          }
        </div>
      </section>

      <div class="brf-transfer__actions">
        <astral-button variant="primary" type="submit" labelKey="SAVE_BTN"></astral-button>
        <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
      </div>
    </form>
  </section>
}
